import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from './en/translation.json';
import translationIS from './is/translation.json';

// the translations
const resources = {
  en: {
    translation: translationEN
  },
  is: {
    translation: translationIS
  },
};

// Normalize a language code (e.g. "en-US", "is-IS") to one of our supported
// codes ("en" or "is"). Falls back to "is" for unsupported languages.
const normalizeLang = (lng) => {
  if (!lng) return 'is';
  const base = String(lng).toLowerCase().split('-')[0];
  return base === 'en' ? 'en' : 'is';
};

const getInitialLang = () => {
  if (typeof localStorage === 'undefined') return 'is';
  return normalizeLang(localStorage.getItem('lang'));
};

// Keep <html lang="..."> in sync with the active i18n language so that screen
// readers, browser spellcheckers and other a11y tools get the correct hint.
// We keep translate="no" / class="notranslate" set regardless of language
// (see public/index.html) to prevent Google Translate / Chrome built-in
// translation from mutating the DOM and breaking React reconciliation.
const syncHtmlLang = (lng) => {
  if (typeof document === 'undefined') return;
  document.documentElement.setAttribute('lang', normalizeLang(lng));
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: getInitialLang(),
    fallbackLng: "is", // use en if detected lng is not available

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;